/*
* @type 折线柱状散点组合图
* @author xuyao
*/
import React, { PureComponent } from 'react';
import { colors, tooltipStyles } from './config/config';
import extend from './utils/extend';
import { getLegendData, createStandardData } from './utils/util';
import EchartBase from './base/EchartBase';

class BBDLineBar extends PureComponent {
    constructor(props) {
        super(props);
    }

    setOption(param){
        let {
            color = colors.color.slice(),
            category = [],          // 类别
            horizontal = false,     // 横向图
            barData = [],           // 柱状图数据
            barStack,               // 柱状图stack
            barMaxWidth = 20,       // 柱状图宽
            lineData = [],          // 折线数据
            lineStack,              // 折线stack
            lineLabelShow = false,  // 折线是否显示标签
            lineSymbol,             // 折线标记类型
            lineSymbolSize = 6,     // 折线标记大小
            areaShow = true,        // 折线堆叠是否显示
            smooth,                 // 线条是否平滑过渡
            scatterData = [],       // 散点图数据
            scatterSymbolSize = 10, // 散点大小
            scatterItemStyle,
            ...others               // 其他需要特殊配置的参数，格式与echarts格式一致
        } = param;
        let series = [], barSeries = [], lineSeries = [], scatterSeries = [];

        const barBaseSeries = {    // 柱状图默认配置
            type: 'bar',
            barMaxWidth,
            stack: barStack
        };

        const lineBaseSeries = {   //  折线默认配置
            type: 'line',
            smooth,
            lineSymbol,
            symbolSize: lineSymbolSize,
            stack: lineStack,
            label: {
                normal: {
                    show: lineLabelShow
                }
            }
        };

        const scatterBaseSeries = {
            type: 'scatter',
            symbolSize: scatterSymbolSize,
            itemStyle: scatterItemStyle
        };

        barSeries = createStandardData(barData, barBaseSeries);
        lineSeries = createStandardData(lineData, lineBaseSeries);
        scatterSeries = createStandardData(scatterData, scatterBaseSeries);

        if (areaShow) {
            lineSeries.forEach((d, index) => {
                if(d.areaStyle === undefined) {
                    d.areaStyle = {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: color[(index + barSeries.length) % color.length]  // 0% 处的颜色
                            }, {
                                offset: 1, color: 'white' // 100% 处的颜色
                            }],
                            globalCoord: false // 缺省为 false
                        },
                        origin: 'start',
                        opacity: 0.2
                    };
                }
            });
        }

        series = series.concat(barSeries, lineSeries, scatterSeries);

        if (horizontal) { // 如果坐标翻转。数据也翻转
            category = [...category].reverse();
            series.forEach(s => s.data = [...s.data].reverse() );
        }

        const option = {
            color,
            title: {
                show: false,
                link: '',
                target: 'self',
                text: '',
                x: 'left',
                padding: [25, 0, 0, 5],
                textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal',
                    fontFamily: 'Microsoft Yahei'
                }
            },
            tooltip: {
                trigger: 'axis',
                padding: [5, 10, 5, 10],
                axisPointer: {
                    type: 'none'
                },
                ...tooltipStyles
            },
            legend: {
                padding: [0, 0, 0, 0],
                itemGap: 20,
                itemWidth: 25,
                itemHeight: 12,
                width: 'auto',
                show: true,
                left: 'auto',
                right: '28',
                bottom: 'auto',
                top: '0',
                data: getLegendData(series),
                textStyle: {
                    color: colors.legendColor,
                    fontSize: 14,
                    fontFamily: 'Microsoft Yahei'
                }
            },
            grid: {
                top: 15,
                left: 10,
                right: 15,
                bottom: 15,
                containLabel: true
            },
            xAxis: [{
                name: '',
                type: 'category',
                boundaryGap: barSeries.length !== 0 || horizontal,
                data: category,
                axisLine: {
                    lineStyle: {
                        color: colors.axisLineColor
                    }
                },
                axisLabel: {
                    color: colors.textColor,
                    textStyle: {
                        fontSize: 12,
                        fontFamily: 'Microsoft Yahei'
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#DDE0E5'
                    }
                }
            }],
            yAxis: [{
                type: 'value',
                data: [],
                name: '',
                axisLine: {
                    lineStyle: {
                        color: colors.axisLineColor
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: colors.textColor,
                    textStyle: {
                        fontSize: 12,
                        fontFamily: 'Microsoft Yahei'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: colors.splitLineColor
                    }
                }
            }, {
                type: 'value',
                name: '',
                data: [],
                axisLine: {
                    show: false, // 控制右边的Y轴显不显示
                    lineStyle: {
                        color: colors.axisLineColor
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    show: false,
                    color: colors.textColor,
                    textStyle: {
                        fontSize: 12,
                        fontFamily: 'Microsoft Yahei'
                    }
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: colors.splitLineColor
                    }
                }
            }],
            series
        };
        let op = extend(true, {}, option, others);
        if (horizontal) {
            let cAxis = op.xAxis;
            op.xAxis = op.yAxis.slice(0, 1);
            op.yAxis = cAxis;
        }
        return op;
    }
    render() {
        return (
            <EchartBase onEvents={this.props.onEvents} option={this.setOption(this.props.option)} style = {this.props.style} />
        );
    }
}
export default BBDLineBar;



// WEBPACK FOOTER //
// ./src/components/common/echarts/BBDLineBar.jsx